<script setup>
import useLoaderStore from '@/stores/loader';
const loaderStore = useLoaderStore();
</script>

<template>
    <v-dialog
        v-model="loaderStore.isLoading"
        :width="'auto'"
        class="rounded-0"
        persistent
    >
        <v-card color="primary">
            <v-card-text>
                {{ $t('Loading') }}...
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
